export default __webpack_public_path__ + "static/media/Q12_3_resized.5f9b6a3b.jpg";